import React, { useEffect, useState } from 'react';
import { fetchAllCountriesAndBanks, segregateRefundDetails } from '../../../studentRefundRequest/multiTypeRefund/utils';
import ViewRefundDetails from './viewComponents/ViewRefundDetails';
import ViewRefundItem from './viewComponents/ViewRefundItem';
import ViewRefundAccounts from './viewComponents/ViewRefundAccounts';
import ALoader from '../../../../../views/pages/manage/common/a-loader';

const MultiTypeRefundDetailsCard = ({ details }) => {

  const { refundItemDetails, refundDetails, refundAccountDetails, withdrawalFeeSummary, dlpWithdrawalRefundDetails } = segregateRefundDetails(details);
  const {career} = details ?? {};
  const isDLPCase = career === 'DLP';

  const [dropdownData, setDropdownData] = useState({ loading: false, data: {} });

  useEffect(() => {

    const fetchDropdownData = async () => {
      try {
        setDropdownData(prev => ({ ...prev, loading: true }));
        const resp = await fetchAllCountriesAndBanks();
        setDropdownData(prev => ({
          ...prev,
          data: resp
        }))

      } catch (err) {
        console.error(err);
      } finally {
        setDropdownData(prev => ({ ...prev, loading: false }));
      }
    }

    fetchDropdownData();

  }, [])



  return (
    <div className='d-flex flex-column mb-3' style={{ gap: '0.5rem' }}>
      {dropdownData?.loading && <ALoader position={"fixed"} />}
      <div className='a-card m-0'>

        <h3>Refund Details</h3>

        <ViewRefundDetails refundDetails={refundDetails} isDLPCase={isDLPCase} />
        <ViewRefundItem
          refundItemDetails={refundItemDetails}
          withdrawalFeeSummary={withdrawalFeeSummary}
          dlpWithdrawalRefundDetails={dlpWithdrawalRefundDetails}
          isDLPCase={isDLPCase}
        />

      </div>

      <ViewRefundAccounts
        refundAccountDetails={refundAccountDetails}
        dropdownData={dropdownData}
      />

    </div>
  );
}

export default MultiTypeRefundDetailsCard;